import { render, staticRenderFns } from "./marketingFreightSubsidyRecords.vue?vue&type=template&id=250c9ca8&scoped=true"
import script from "./marketingFreightSubsidyRecords.vue?vue&type=script&lang=js"
export * from "./marketingFreightSubsidyRecords.vue?vue&type=script&lang=js"
import style0 from "./marketingFreightSubsidyRecords.vue?vue&type=style&index=0&id=250c9ca8&prod&scoped=true&lang=css"
import style1 from "./marketingFreightSubsidyRecords.vue?vue&type=style&index=1&id=250c9ca8&prod&lang=css"
import style2 from "./marketingFreightSubsidyRecords.vue?vue&type=style&index=2&id=250c9ca8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250c9ca8",
  null
  
)

export default component.exports